import * as React from "react";
import { LucideIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

export function NavMain({
  items,
  ...props
}: {
  items: {
    title: string;
    url: string;
    icon: LucideIcon;
  }[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const navigate = useNavigate();

  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem className="text-xs font-medium text-muted-foreground px-3 py-1">
            Dashboard & Settings
          </SidebarMenuItem>
          {items.map((item) => (
            <SidebarMenuButton
              key={item.title}
              onClick={() => navigate(item.url)}
              className="text-sm"
            >
              <item.icon className="h-4 w-4" />
              {item.title}
            </SidebarMenuButton>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
